import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Trash2, Eye, EyeOff } from "lucide-react";
import { api, imgUrl, formatErr } from "@/lib/api";

export default function AdminPhotos() {
  const [photos, setPhotos] = useState([]);
  const [title, setTitle] = useState("");
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.get("/admin/photos").then((r) => setPhotos(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        fd.append("title", title);
        await api.post("/admin/photos", fd);
      }
      toast.success("Foto caricate");
      setTitle("");
      load();
    } catch (er) {
      toast.error(formatErr(er));
    } finally {
      setBusy(false);
      fileRef.current.value = "";
    }
  };

  const toggle = async (p) => { await api.patch(`/admin/photos/${p.id}`, { visible: !p.visible }); load(); };
  const del = async (p) => {
    if (!window.confirm("Eliminare questa foto?")) return;
    await api.delete(`/admin/photos/${p.id}`);
    toast.success("Foto eliminata");
    load();
  };

  return (
    <div data-testid="admin-photos">
      <div className="bg-[#121215] border border-zinc-800 p-6 flex flex-col md:flex-row gap-4 md:items-center mb-8">
        <input className="tms-input md:max-w-sm" placeholder="Titolo (opzionale)" value={title} onChange={(e) => setTitle(e.target.value)} data-testid="admin-photo-title-input" />
        <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp" multiple className="hidden" onChange={upload} data-testid="admin-photo-file-input" />
        <button className="btn-red" disabled={busy} onClick={() => fileRef.current.click()} data-testid="admin-photo-upload-button"><Upload size={16} /> {busy ? "Caricamento…" : "Carica foto"}</button>
        <span className="text-xs text-zinc-500">JPG, PNG, WEBP · max 10 MB</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {photos.map((p) => (
          <div key={p.id} className={`border ${p.visible ? "border-zinc-800" : "border-dashed border-zinc-700 opacity-60"} bg-[#18181C]`} data-testid={`admin-photo-${p.id}`}>
            <img src={imgUrl(p.url)} alt={p.title} className="w-full aspect-square object-cover" />
            <div className="p-3 flex items-center justify-between gap-2">
              <span className="text-xs text-zinc-400 truncate">{p.title || "Senza titolo"}</span>
              <div className="flex gap-1">
                <button onClick={() => toggle(p)} className="p-1.5 hover:text-red-500" title={p.visible ? "Nascondi" : "Mostra"} data-testid={`admin-photo-toggle-${p.id}`}>{p.visible ? <Eye size={16} /> : <EyeOff size={16} />}</button>
                <button onClick={() => del(p)} className="p-1.5 hover:text-red-500" data-testid={`admin-photo-delete-${p.id}`}><Trash2 size={16} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
